import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { environment } from '../../../environments/environment';
export interface DialogData 
{
    nombre: any,    
    telefono: any,
    celular: any,
    mail: any,
    prevision: any,
    beneficiarios: any
}

@Component({
    selector: 'modal-info-beneficiario',
    templateUrl: '../../pages/common/modal-info-beneficiario.component.html',
    styleUrls: ['../../pages/common/postulacion-rechazar.css'],
})
export class ModalInfoBeneficiario
{  
    constructor( public dialogRef: MatDialogRef<ModalInfoBeneficiario>, 
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, ) 
                 { console.log(data.beneficiarios)}

    onCancelarClick(): void { this.dialogRef.close() }  

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, { 
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}